import { RFWebPermissaoEnum } from 'app/shared/auth/permissao/cadastro-menu-routes-permission.config';
import { RouteInfo } from 'app/shared/vertical-menu/vertical-menu.metadata';
// import { ACadastroControleAcessoPermissaoEnum } from './../permissao/RFWebCadastroControleAcessoPermissaoEnum';

export const CADASTRO_MENU_ROUTES: RouteInfo[] = [
  // path: '', title: 'Cadastros', icon: 'fa fa-id-card', id: 0,
  // class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
  // submenu: [
  {
    path: '', title: 'Grupos', icon: 'fa fa-object-group', id: 1, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroMenuGrupo,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: 'cadastro/grupo', title: 'Grupo Econômico', icon: 'fa fa-object-group', id: 2,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroGrupo
      },
      // {
      //   path: 'cadastro/grupo', title: 'Grupos Região', icon: 'fa fa-object-group', id: 3,
      //   class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
      //   authGuardKey: RFWebPermissaoEnum.rfpCadastroGrupoRegiao
      // },
    ],
  },
  {
    path: '', title: 'Players', icon: 'fa fa-play', id: 4, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroMenuPlayer,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro/player', title: 'Cadastro', icon: 'fa fa-object-group', id: 5,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroPlayer
      },
      {
        path: '/cadastro/player-ramo', title: 'Ramo Atividade', icon: 'fa fa-object-group', id: 6,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroPlayerRamoAtividade
      },
      {
        path: '', title: 'Consultas', icon: 'fa fa-search', id: 27, willHaveSub: true,
        class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
        authGuardKey: RFWebPermissaoEnum.rfpConsultalPlayerMenu, submenu: [
          {
            path: '/cadastro/player/consulta/mais-ouvidos', title: 'Mais Ouvidas', icon: 'fa fa-music', id: 28,
            class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
            authGuardKey: RFWebPermissaoEnum.rfpConsultalPlayerMaisOuvidas
          },
          {
            path: '/cadastro/player/consulta/deletados', title: 'Deletados', icon: 'fa fa-trash', id: 29,
            class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
            authGuardKey: RFWebPermissaoEnum.rfpConsultalPlayerDeletado
          },
        ]
      },
    ],
  },
  {
    path: '', title: 'Coletâneas', icon: 'fa fa-list', id: 7, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroMenuColetanea,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro/coletanea', title: 'Coletâneas', icon: 'fa fa-object-group', id: 8,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroColetanea
      },
      {
        path: '/cadastro/coletanea-grupo', title: 'Grupo de Coletâneas', icon: 'fa fa-object-group', id: 9,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroGrupoColetanea
      },
    ],
  },
  {
    path: '', title: 'Spots', icon: 'fa fa-microphone', id: 10, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroMenuSpot,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro/spot', title: 'Spots', icon: 'fa fa-object-group', id: 11,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroSpot
      },
      {
        path: '/cadastro/spot-agendamento', title: 'Agendamento', icon: 'fa fa-object-group', id: 12,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroSpotAgendamento
      },
      {
        path: '', title: 'Consultas', icon: 'fa fa-search', id: 27, willHaveSub: true,
        class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
        authGuardKey: RFWebPermissaoEnum.rfpConsultaSpotMenu, submenu: [
          {
            path: '/cadastro/spot/consulta/mais-ouvidos', title: 'Mais Ouvidas', icon: 'fa fa-music', id: 28,
            class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
            authGuardKey: RFWebPermissaoEnum.rfpConsultaSpotMaisOuvido
          }
        ]
      },
    ],
  },
  {
    path: '', title: 'Anúncios', icon: 'fa fa-bullhorn', id: 13, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroMenuAnuncios,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro/anuncio', title: 'Template de Anúncios', icon: 'fa fa-object-group', id: 14,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroAnuncios
      },
      {
        path: '/cadastro/anuncio-parametros', title: 'Parametrização de Anúncios', icon: 'fa fa-object-group', id: 15,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroAnunciosParametros
      },
    ],
  },
  //   ]
  // }
]
